import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type ArrowLeftProps = React.HTMLAttributes<HTMLDivElement> & {};

export const ArrowLeft: React.FC<ArrowLeftProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/svg/arrow_left.svg"} alt="" />
    </div>
  );
};